import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import cx from 'classnames';
import {
    FormGroup,
    FormControl,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';

// Helper
import PopulateData from '../../../helpers/populateData';

// Locale
import messages from '../../../locale/jsonMessages';
import CountryList from '../../CountryList';

import cs from '../../../components/commonStyle.css';
import s from './Payment.css';

class DriverInfo extends Component {

    static propTypes = {
        formatMessage: PropTypes.any,
        paymentType: PropTypes.number
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            lookupData: {},
            countryCode: 'US',
            country: '+1',
        }
        this.renderField = this.renderField.bind(this);
        this.renderFormControl = this.renderFormControl.bind(this);
        this.renderFormControlSelect = this.renderFormControlSelect.bind(this);
        this.renderCountryList = this.renderCountryList.bind(this);
    }

    UNSAFE_componentWillMount() {
        let now = new Date();
        let currentYear = now.getFullYear();
        let years = PopulateData.generateData(1900, currentYear, "desc");
        let months = PopulateData.generateData(0, 11);
        let days = PopulateData.generateData(1, 31);

        this.setState({
            lookupData: {
                years: years,
                months: months,
                days: days
            }
        });
    }

    renderField({ input, label, type, placeholder, meta: { touched, error, dirty }, disabled, className, maxLength }, isRequiredInput) {
        const { formatMessage } = this.props.intl;
        return (
            <FormGroup className={cx(cs.noMargin)}>
                <label className='commonLabelText'>{label}{isRequiredInput && <sup className='isRequiredStar'>*</sup>}</label>
                <FormControl disabled={disabled} {...input} componentClass="input" placeholder={placeholder} className={className} maxLength={maxLength} />
                {touched && error && <span className={cs.errorMessage}>{formatMessage(error)}</span>}
            </FormGroup>
        );
    }

    renderFormControl({ input, label, type, placeholder, meta: { touched, error, dirty }, disabled, className, maxLength }, isRequiredInput) {
        const { formatMessage } = this.props.intl;
        return (
            <FormGroup className={cs.noMargin}>
                <label className='commonLabelText'>{label}{isRequiredInput && <sup className='isRequiredStar'>*</sup>}</label>
                <FormControl disabled={disabled} {...input} componentClass="input" placeholder={placeholder} className={className} maxLength={maxLength} />
                {touched && error && <span className={cs.errorMessage}>{formatMessage(error)}</span>}
            </FormGroup>
        );
    }

    renderFormControlSelect({ input, placeholder, meta: { touched, error }, children, className, disabled }) {
        const { formatMessage } = this.props.intl;
        return (
            <FormGroup className={cx(cs.noMargin)}>
                <FormControl disabled={disabled} componentClass="select" {...input} className={className} >
                    {children}
                </FormControl>
                {touched && error && <span className={cs.errorMessage}>{formatMessage(error)}</span>}
            </FormGroup>
        )
    }

    renderCountryList({ input, label, meta: { touched, error }, children, className, disabled, isRequiredInput }) {
        const { formatMessage } = this.props.intl;
        return (
            <FormGroup className={cs.noMargin}>
                <label className='commonLabelText'>{label}{isRequiredInput && <sup className='isRequiredStar'>*</sup>}</label>
                <CountryList input={input} className={className} disabled={disabled} />
                {touched && error && <span className={cs.errorMessage}>{formatMessage(error)}</span>}
            </FormGroup>
        );
    }

    render() {
        const { handleSubmit, submitting, error, pristine, paymentType, disabled } = this.props;
        const { lookupData } = this.state;
        const { formatMessage } = this.props.intl;
        return (
            <div className={cx(s.creditCardForm)}>
                <div className="oneColumnGrid">
                    <Field
                        name="licenseNumber"
                        component={this.renderFormControl}
                        placeholder={formatMessage(messages.licenseNumber)}
                        label={formatMessage(messages.licenseNumber)}
                        className='commonInputField'
                        disabled={disabled}
                        maxLength={255}
                        isRequiredInput
                    />
                    <div className={s.displayGridFirstName}>
                        <Field
                            name="firstName"
                            component={this.renderField}
                            placeholder={formatMessage(messages.firstName)}
                            label={formatMessage(messages.firstName)}
                            className='commonInputField'
                            disabled={disabled}
                            maxLength={30}
                            isRequiredInput
                        />
                        <Field
                            name="lastName"
                            component={this.renderField}
                            placeholder={formatMessage(messages.lastName)}
                            label={formatMessage(messages.lastName)}
                            className='commonInputField'
                            disabled={disabled}
                            maxLength={30}
                            isRequiredInput
                        />
                    </div>
                    <div>
                        <Field
                            name="country"
                            component={this.renderCountryList}
                            label={formatMessage(messages.country)}
                            className='commonSelectField'
                            disabled={disabled}
                            isRequiredInput

                        />
                    </div>

                    <div>
                        <label className='commonLabelText'>{formatMessage(messages.dateOfBirth)}  <sup className='isRequiredStar'>*</sup></label>
                        <div className={s.dateFiledGrid}>
                            <Field name="month" component={this.renderFormControlSelect} className='commonSelectField' disabled={disabled}>
                                <option value="">{formatMessage(messages.month)}</option>
                                {
                                    lookupData.months.map((item, key) => {
                                        return (
                                            <option key={key} value={item}>{item + 1}</option>
                                        )
                                    })
                                }
                            </Field>
                            <Field name="day"
                                component={this.renderFormControlSelect}
                                className='commonSelectField'
                                disabled={disabled}
                            >
                                <option value="">{formatMessage(messages.transferDate)}</option>
                                {
                                    lookupData.days.map((item, key) => {
                                        return (
                                            <option key={key} value={item}>{item}</option>
                                        )
                                    })
                                }
                            </Field>
                            <Field
                                name="year"
                                component={this.renderFormControlSelect}
                                className='commonSelectField'
                                disabled={disabled}
                            >
                                <option value="">{formatMessage(messages.expiryYear)}</option>
                                {
                                    lookupData.years.map((item, key) => {
                                        return (
                                            <option key={key} value={item}>{item}</option>
                                        )
                                    })
                                }
                            </Field>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapState = (state) => ({});

const mapDispatch = {};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(DriverInfo)));